import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { PageHeader, Card, Loading } from "../../components/common";
import { Button } from "../../components/ui/button";
import { Checkbox } from "../../components/ui/checkbox";

export default function AdminPermissions() {
  const { meta } = useAuth();
  const [roles, setRoles] = useState(null);
  const [dirty, setDirty] = useState({});
  useEffect(() => { api.get("/admin/roles").then((r) => setRoles(r.data)); }, []);
  if (!roles) return <Loading />;
  const toggle = (key, p) => {
    setRoles((rs) => rs.map((r) => (r.key === key ? { ...r, perms: r.perms.includes(p) ? r.perms.filter((x) => x !== p) : [...r.perms, p] } : r)));
    setDirty((d) => ({ ...d, [key]: true }));
  };
  const save = async () => {
    try {
      for (const k of Object.keys(dirty)) await api.put(`/admin/roles/${k}`, { perms: roles.find((r) => r.key === k).perms });
      setDirty({}); toast.success("Permissões salvas e registradas na auditoria");
    } catch (e) { toast.error(errMsg(e)); }
  };
  const order = meta.roles.map((r) => r.key);
  const sorted = [...roles].sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key));
  return (
    <div>
      <PageHeader eyebrow="Administração master" title="Perfis e permissões" subtitle="Todas as permissões são configuráveis. Alterações valem no próximo acesso de cada usuário."
        actions={<Button data-testid="permissions-save-button" disabled={!Object.keys(dirty).length} onClick={save}>Salvar alterações</Button>} />
      <Card className="overflow-x-auto"><table className="text-sm" data-testid="permissions-matrix">
        <thead className="bg-slate-50 text-xs text-slate-500"><tr><th className="text-left font-medium px-4 py-3 sticky left-0 bg-slate-50 min-w-[260px]">Permissão</th>{sorted.map((r) => <th key={r.key} className="px-3 py-3 font-medium text-center min-w-[110px]">{r.label}</th>)}</tr></thead>
        <tbody>{meta.permissions.map((p) => (
          <tr key={p.key} className="border-t hover:bg-slate-50/50"><td className="px-4 py-2.5 sticky left-0 bg-white"><div className="text-slate-800">{p.label}</div><div className="font-mono text-[10px] text-slate-400">{p.key}</div></td>
            {sorted.map((r) => <td key={r.key} className="text-center"><Checkbox data-testid={`perm-${r.key}-${p.key}`} checked={r.perms.includes(p.key)} disabled={r.key === "master_admin" && p.key === "admin.access"} onCheckedChange={() => toggle(r.key, p.key)} /></td>)}</tr>))}</tbody>
      </table></Card>
    </div>
  );
}
